import PicklistMetadata from "../PicklistMetadata";

// The seeded 'Data Type Physical Type' list. Static, so the options come from the session's PICK_VALUES rather
// than a query -- the same shape Connection Type uses.
//
// CLOSED: a tenant cannot extend it. The values are branches in the resolver and projection code,
// not data. It is a pick list because that is how this app draws a Select.
class DataTypePhysicalTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "DataTypePhysicalType";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Data Type Physical Type";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default DataTypePhysicalTypePicklistMetadata;
